import styled from 'styled-components';

interface HeaderShadowWrapperProps {
  useDefaultBackground?: boolean;
}

export const HeaderShadowWrapper = styled.div<HeaderShadowWrapperProps>`
  background-color: ${(props) => 
    props.useDefaultBackground 
      ? props.theme.colors.defaultContentBackground 
      : props.theme.colors.spruceDefaultContentBackground
  };
  box-shadow: 0px 1px 3px ${(props) => props.theme.colors.shadowVariant1},
    0px 1px 2px ${(props) => props.theme.colors.shadowVariant2};
`;
